import { SearchCepProviderInterface } from '../../domain/city/interfaces/providers/search-cep.provider.interface';
import { GetCepDetailsOutput } from '../../domain/city/dtos/get-cep-details.output';
import { Types } from '../../domain/types.domain';
import { inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

export class SearchCepProvider implements SearchCepProviderInterface {
  private readonly _settings = inject(Types.Settings);
  private readonly _http = inject(HttpClient);

  async handle(cep: string): Promise<GetCepDetailsOutput> {
    try {
      const response = await this._http.get<GetCepDetailsOutput>(
        `${this._settings.integrationsUrl.v1}/hub-desenvolvedor/cep/${cep}`
      ).toPromise();

      if (!response) {
        return { error: 'unavailable' };
      }

      return response;
    } catch (error: unknown) {
      const status = (error as { status?: number })?.status;
      if (status === 400 || status === 404) {
        return { error: 'not_found' };
      }
      return { error: 'unavailable' };
    }
  }
}
